export const formatTime = (value: string) => {
  const formattedValue = value.replace(/\D/g, '')

  return formattedValue.replace(/^(\d{2})(\d{2})/g, '$1:$2')
}